/** Small connection-status badge (top-right). partysocket auto-reconnects. */

import { useGameStore } from '../state/store';

const LABEL: Record<string, string> = {
  idle: 'Connecting…',
  connecting: 'Connecting…',
  open: 'Connected',
  closed: 'Reconnecting…',
  error: 'Reconnecting…',
};

export function ConnectionBadge() {
  const connection = useGameStore((s) => s.connection);
  return (
    <div className={`conn-badge conn-${connection}`}>
      <span className="conn-badge__dot" />
      {LABEL[connection] ?? connection}
    </div>
  );
}
